let localIdCounter = 0;

export const ATTACHMENT_FLAG = '__nocAttachment';

const nextLocalId = () => {
  localIdCounter += 1;
  return `local-${Date.now()}-${localIdCounter}`;
};

export const createAttachmentFromMedia = (entry) => {
  if (!entry) return null;
  if (entry[ATTACHMENT_FLAG]) {
    return cloneAttachment(entry);
  }

  const attributes = entry.attributes || entry;
  const id = entry.id ?? attributes.id ?? null;

  return {
    [ATTACHMENT_FLAG]: true,
    id,
    documentId: attributes.documentId ?? entry.documentId ?? null,
    name: attributes.name ?? '',
    mime: attributes.mime ?? '',
    size: attributes.size ?? null,
    hash: attributes.hash ?? '',
    ext: attributes.ext ?? '',
    url: attributes.url ?? entry.url ?? null,
    formats: attributes.formats ?? null,
    status: 'loaded',
    localId: id ? `server-${id}` : nextLocalId(),
  };
};

export const createAttachmentFromFile = (file) => {
  if (!file) return null;
  return {
    [ATTACHMENT_FLAG]: true,
    id: null,
    name: file.name,
    mime: file.type,
    size: file.size,
    status: 'new',
    file,
    localId: nextLocalId(),
  };
};

export const cloneAttachment = (attachment) => {
  if (!attachment) return null;
  return {
    ...attachment,
  };
};

export const ensureAttachmentArray = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => {
      if (!item) return null;
      if (item[ATTACHMENT_FLAG]) {
        return cloneAttachment(item);
      }
      return createAttachmentFromMedia(item);
    })
    .filter(Boolean);
};

export const isAttachmentArray = (value) => {
  if (!Array.isArray(value) || value.length === 0) return false;
  return value.every((item) => item && item[ATTACHMENT_FLAG]);
};

export const visibleAttachments = (list = []) =>
  ensureAttachmentArray(list).filter((item) => item.status !== 'delete');
